/**
 * 缓存命名规范
 */
enum AuthorizeEnum {
  NAME = 'auth',
  // 用户详情
  COMPANY = 'company',

  LEVEL = 'level',
  // 用户token
}
export default AuthorizeEnum;
